var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.series.length)?_c('GlobalGraph',{key:_vm.componentKey,staticClass:"graph",attrs:{"series":_vm.series,"xAxisData":_vm.xAxis,"yAxis":_vm.yAxis,"title":_vm.graphTitle,"loading":_vm.loading,"theme":_vm.theme}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }